import React, { useEffect, useState } from "react";
import { useLazyGetAcademyHomeDataQuery } from "../../store/api/academyApi";
import { useLocation } from "react-router-dom";
import Modal from "../common/modals";
import {
  AcademyComicsCloseButton,
  AcademyComicsNavigateButton,
} from "../../icons/academy-icons";

interface News {
  type: string;
  thumbnail: string;
  heading: string;
  description: string;
  source: string;
  news_id: string;
  is_active: boolean;
  reference_link: string;
}

function NewsSection() {
  const location = useLocation();
  const [triggerGetAcademyAllTabData] = useLazyGetAcademyHomeDataQuery();
  const [newsData, setNewsData] = useState<any>(null);
  const [newsBytes, setNewsBytes] = useState<News[]>([]);
  const [newsArticles, setNewsArticles] = useState<News[]>([]);
  const [isModalOpen, setIsModalOpen] = useState(
    location.state?.isModalOpen || false,
  );
  const [selectedNews, setSelectedNews] = useState<number>(
    location.state?.selectedNews || 0,
  );
  const [modalType, setModalType] = useState<"bytes" | "articles">(
    location.state?.modalType || "bytes",
  );

  const fetchNewsData = async () => {
    const resp = await triggerGetAcademyAllTabData({
      type: "news",
    }).unwrap();
    setNewsData(resp.data);
  };

  const segregatedNewsData = (newsData: { news_list: { type: string }[] }) => {
    const bytes: any[] = [];
    const articles: any[] = [];
    newsData?.news_list?.map((news: { type: string }) => {
      if (news.type === "News Article") {
        articles.push(news);
      } else {
        bytes.push(news);
      }
    });
    setNewsBytes(bytes);
    setNewsArticles(articles);
  };

  useEffect(() => {
    fetchNewsData();
  }, []);

  useEffect(() => {
    segregatedNewsData(newsData);
  }, [newsData]);

  return (
    <div className="bg-gray-100 min-h-screen">
      <div className="space-y-6">
        {/* News Bytes */}
        <section className="bg-whyte p-6 rounded-lg shadow-md">
          <h2 className="text-2xl font-bold text-gray-800 mb-6">News Bytes</h2>
          <div className="flex flex-wrap justify-start gap-4">
            {newsBytes?.map((byte: News, index: number) => (
              <div
                key={index}
                className="sm:w-1/2 lg:w-1/6 2xl:w-1/8 h-64 bg-whyte relative rounded-lg shadow-lg overflow-hidden hover:shadow-xl transition-shadow duration-300 flex-grow max-w-[180px]"
                onClick={() => {
                  setSelectedNews(index);
                  setModalType("bytes");
                  setIsModalOpen(true);
                }}
              >
                <img
                  src={byte.thumbnail}
                  alt={byte.heading}
                  className="inset-0 h-full w-full object-cover"
                />
                <p className="absolute bottom-5 left-5 font-bold text-[15px] text-white ">
                  {byte.heading && byte.heading.length > 45
                    ? `${byte.heading.slice(0, 45)}...`
                    : byte.heading || "30-SEC BYTES"}
                </p>
              </div>
            ))}
          </div>
        </section>

        {/* News Articles */}
        {/* <section className="bg-whyte p-6 rounded-lg shadow-md">
          <h2 className="text-2xl font-bold text-gray-800 mb-6">
            News Articles
          </h2>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
            {newsArticles?.map((article: News, index: number) => (
              <div
                key={index}
                className="bg-whyte rounded-lg shadow-lg overflow-hidden hover:shadow-xl transition-shadow duration-300"
                onClick={() => {
                  setSelectedNews(index);
                  setModalType("articles");
                  setIsModalOpen(true);
                }}
              >
                <div className="h-44">
                  <img
                    src={article.thumbnail}
                    alt={article.heading}
                    className="inset-0 w-full h-full object-cover"
                  />
                </div>
                <div className="p-4">
                  <h3 className="font-semibold text-gray-800">
                    {article.heading}
                  </h3>
                  <p className="text-gray-500 text-sm mt-2">
                    {article.description}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </section> */}
        <Modal
          isOpen={isModalOpen}
          customClass="!bg-transparent md:!w-fit !max-w-fit md:!max-w-fit md:!h-fit !shadow-none !my-0  md:!p-0 !p-0  !overflow-y-scroll"
          parentCustomClass="!-top-[24px]"
          blurBg={true}
          setModalOpen={setIsModalOpen}
        >
          <div className=" w-fit !bg-white h-fit flex">
            <div className="w-fit h-fit">
              <div
                className="fixed top-[50%] left-[50%] -translate-x-[320px] -translate-y-[50%] left-4"
                onClick={() =>
                  setSelectedNews(
                    (selectedNews -
                      1 +
                      (modalType === "bytes"
                        ? newsBytes?.length
                        : newsArticles?.length)) %
                      (modalType === "bytes"
                        ? newsBytes?.length
                        : newsArticles?.length),
                  )
                }
              >
                <AcademyComicsNavigateButton />
              </div>
              <div className="w-fit flex flex-col">
                <div className="bg-white m-auto !w-[460px]">
                  <div className="w-full h-96">
                    <img
                      src={
                        modalType === "bytes"
                          ? newsBytes?.[selectedNews]?.thumbnail
                          : newsArticles?.[selectedNews]?.thumbnail
                      }
                      alt={
                        modalType === "bytes"
                          ? newsBytes?.[selectedNews]?.heading
                          : newsArticles?.[selectedNews]?.heading
                      }
                      className="w-full inset-0 h-full object-cover"
                    />
                  </div>
                  <div className="px-4 pb-4">
                    <p className="text-3xl font-bold">
                      {modalType === "bytes"
                        ? newsBytes?.[selectedNews]?.heading
                        : newsArticles?.[selectedNews]?.heading}
                    </p>
                    <p className="text-[#404040]">
                      {modalType === "bytes"
                        ? newsBytes?.[selectedNews]?.description
                        : newsArticles?.[selectedNews]?.description}
                    </p>
                  </div>
                  <div className="px-4 pb-4">
                    <div>
                      <span>Source: </span>
                      <a
                        className="text-blue-500 hover:underline"
                        href={
                          modalType === "bytes"
                            ? newsBytes?.[selectedNews]?.reference_link
                            : newsArticles?.[selectedNews]?.reference_link
                        }
                        target="_blank"
                      >
                        {modalType === "bytes"
                          ? newsBytes?.[selectedNews]?.source
                          : newsArticles?.[selectedNews]?.source}
                      </a>
                    </div>
                  </div>
                </div>
              </div>
              <div
                className="fixed top-[50%] right-[50%] translate-x-[320px] -translate-y-[50%] right-4"
                onClick={() =>
                  setSelectedNews(
                    (selectedNews + 1) %
                      (modalType === "bytes"
                        ? newsBytes?.length
                        : newsArticles?.length),
                  )
                }
              >
                <AcademyComicsNavigateButton rotate={180} />
              </div>
            </div>
          </div>
          <div
            className="fixed top-8 right-8"
            onClick={() => setIsModalOpen(false)}
          >
            <AcademyComicsCloseButton width={16} />
          </div>
        </Modal>
      </div>
    </div>
  );
}

export default NewsSection;
